import {
  findLatestAwaitingInteraction,
  findToolPart,
  getProcessingToolPart,
  hasCompletedArtToolInMessages,
  hasCompletedStrategyToolInMessages,
  isArtQueueToolPartType,
} from './toolPartSelectors';
import {CAMPAIGN_WIDGET_TOOL_NAMES} from '../utils/campaignCompletionMessages';
import {
  CAMPAIGN_TYPE_UI_TOOL_NAME,
  LOGO_UI_TOOL_NAME,
  PALETTE_UI_TOOL_NAME,
} from './campaignToolCatalog';

const HYDRATION_TOOL_CATALOG = [
  {toolName: PALETTE_UI_TOOL_NAME},
  {toolName: LOGO_UI_TOOL_NAME},
  {toolName: CAMPAIGN_TYPE_UI_TOOL_NAME},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.QUANTIDADE_ARTES},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.IMAGENS_CAMPANHA},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ESTRATEGIA},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ARTES},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.MODO_CONCLUSAO},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.REDES_SOCIAIS},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.CONFIGURAR_AGENDAMENTO},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.CONFIRMAR_EDICAO_LOTE},
  {toolName: CAMPAIGN_WIDGET_TOOL_NAMES.ACOES_FINAIS},
];

function serverAheadOnArtEditProcessing(storedMessages, localMessages) {
  const serverPart = getProcessingToolPart(storedMessages);
  if (!serverPart || !isArtQueueToolPartType(serverPart.type)) {
    return false;
  }

  const toolName = serverPart.type.replace(/^tool-/, '');
  if (toolName !== 'editar_arte_campanha' && toolName !== 'editar_artes_lote') {
    return false;
  }

  const serverTrackingId =
    serverPart.output?.trackingId || serverPart.toolCallId || null;
  const localPart = getProcessingToolPart(localMessages);
  if (!localPart) {
    return true;
  }

  const localTrackingId =
    localPart.output?.trackingId || localPart.toolCallId || null;
  return Boolean(
    serverTrackingId &&
      serverTrackingId !== localTrackingId &&
      serverPart.output?.status === 'processing',
  );
}

/**
 * Decides when stored server messages must replace the local transcript.
 * Keeps chat widgets in sync after reload/refetch when the server is ahead.
 */
export function needsServerMessageHydration(storedMessages, localMessages) {
  const serverPendingInteraction = findLatestAwaitingInteraction(
    storedMessages,
    HYDRATION_TOOL_CATALOG,
  );
  const localPendingInteraction = findLatestAwaitingInteraction(
    localMessages,
    HYDRATION_TOOL_CATALOG,
  );

  if (
    serverPendingInteraction &&
    (!localPendingInteraction ||
      localPendingInteraction.toolName !== serverPendingInteraction.toolName ||
      localPendingInteraction.trackingId !== serverPendingInteraction.trackingId)
  ) {
    return true;
  }

  const serverHasStrategyApproval = Boolean(
    findToolPart(
      storedMessages,
      CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ESTRATEGIA,
      {statuses: ['awaiting_selection']},
    ),
  );
  const localHasStrategyApproval = Boolean(
    findToolPart(
      localMessages,
      CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ESTRATEGIA,
      {statuses: ['awaiting_selection', 'completed']},
    ),
  );

  if (serverHasStrategyApproval && !localHasStrategyApproval) {
    return true;
  }

  const serverHasArtsApproval = Boolean(
    findToolPart(
      storedMessages,
      CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ARTES,
      {statuses: ['awaiting_selection']},
    ),
  );
  const localHasArtsApproval = Boolean(
    findToolPart(
      localMessages,
      CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ARTES,
      {statuses: ['awaiting_selection', 'completed']},
    ),
  );

  if (serverHasArtsApproval && !localHasArtsApproval) {
    return true;
  }

  if (
    hasCompletedStrategyToolInMessages(storedMessages) &&
    !hasCompletedStrategyToolInMessages(localMessages)
  ) {
    return true;
  }

  if (
    hasCompletedArtToolInMessages(storedMessages) &&
    !hasCompletedArtToolInMessages(localMessages)
  ) {
    return true;
  }

  if (serverAheadOnArtEditProcessing(storedMessages, localMessages)) {
    return true;
  }

  return false;
}
